import React, { Fragment } from 'react';
import { Menu, Transition } from '@headlessui/react';

const FONT_SIZE = [
  {
    label: 'Small',
    value: '12px',
  },
  {
    label: 'Medium',
    value: '14px',
  },
  {
    label: 'Large',
    value: '18px',
  },
];

const THEME = [
  {
    label: 'Light',
    value: 'vs-light',
  },
  {
    label: 'Dark',
    value: 'vs-dark',
  },
];

const DropDownSettings = ({ config, setConfig }) => {
  return (
    <Menu as="div" className="relative">
      <Transition
        as={Fragment}
        show={true}
        enter="transition ease-out duration-100"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="absolute -right-2 top-5 z-50 h-auto w-auto rounded-md bg-white shadow-lg ring-1">
          <div className="px-4 py-2 normal-case">
            <Menu.Item>
              <div onClick={(e) => e.stopPropagation()}>
                <div className="text-left text-black">Font Size</div>
                <div className="mb-2 flex gap-4 ">
                  {FONT_SIZE.map((item) => (
                    <div
                      key={item.label}
                      className={
                        config.fontSize === item.value
                          ? 'rounded-md bg-red px-3 py-0.5 font-satoshi-medium text-[14px] font-semibold text-white ring-1 ring-red'
                          : 'cursor-pointer rounded-md px-3 py-0.5 text-[14px] text-red ring-1 ring-red'
                      }
                      onClick={() => setConfig((prev) => ({ ...prev, fontSize: item.value }))}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              </div>
            </Menu.Item>

            <Menu.Item>
              <div onClick={(e) => e.stopPropagation()}>
                <div className="text-left text-black">Theme</div>
                <div className="mb-2 flex gap-4">
                  {THEME.map((item) => (
                    <div
                      key={item.label}
                      className={
                        config.theme === item.value
                          ? 'rounded-md bg-red px-3 py-0.5 font-satoshi-medium text-[14px] font-semibold text-white ring-1 ring-red'
                          : 'cursor-pointer rounded-md px-3 py-0.5 text-[14px] text-red ring-1 ring-red'
                      }
                      onClick={() => setConfig((prev) => ({ ...prev, theme: item.value }))}
                    >
                      {item.label}
                    </div>
                  ))}
                </div>
              </div>
            </Menu.Item>
          </div>
        </Menu.Items>
      </Transition>
    </Menu>
  );
};

export default DropDownSettings;
